import Vue from "vue";

import App from "./App";
import router from "./router";
import "./filters";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(IconsPlugin);

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// Iconografias Font Awesome
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "./styles/style.scss";

import TextoResaltado from "./app_components/TextoResaltado";
Vue.component("texto-resaltado", TextoResaltado);
// Componentes globales
import AppTable from "./app_components/AppTable";
Vue.component("app-table", AppTable);

Vue.config.productionTip = true;
Vue.config.devtools = true;

// store
import store from "./store";
store.commit("load");

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
